module.exports = __webpack_public_path__ + "static/bulova-9a66a3ff99488abfffeba4da5110f46c.png";